export default "__VITE_ASSET__Cx1o$1mE__"